export default "__VITE_ASSET__BiOs8DUT__"